<template>
    <a-tabs v-model="active" :forceRender="true" @change="changeTabs">
      <a-tab-pane key="1" tab="基本信息">
        <Info :uidObj="uidObj" :userInfo="userInfo" @setIntentionFn="setIntentionFn" />
        
        <a-divider />
        <h3 class="demand">需求</h3>
        <template v-if="type !== 'sale'">
          <demand-content :userInfo="userInfo"></demand-content>
        </template>
        <template v-else>
          <sell-demand-content :userInfo="userInfo"></sell-demand-content>
        </template>
        
        <a-divider />
        <h3 class="demand">备注</h3>
        <p style="height: 100px">{{ userInfo.otherInfo ? userInfo.otherInfo : '暂时没有备注信息' }}</p>
        <!-- 底部动态 -->
        <div class="bot-detail">
          <a-row>
            <a-col :span="12">
              <p>动态</p>
              <div class="child" v-if="userInfo.accendantId === uidObj.userId">
                <span class="iconfont icon-bianji1" style="font-size: 20px; color: var(--ThemeColor)"></span>
                <span @click="toFollow" style="cursor: pointer">写跟进</span>
                <span @click="openLookModal" style="cursor: pointer">录带看</span>
                <span @click="openInterviewModal" style="cursor: pointer">录面访</span>
              </div>
            </a-col>
            <a-col :span="12">
              <p>相关人员</p>
              <!-- <span class="iconfont icon-bianji1" style="font-size: 20px; color: var(--ThemeColor)"></span>
              <span>编辑人员</span> -->
            </a-col>
          </a-row>
          <div class="bot-detail-bot">
            <!-- 动态列表 -->
            <Dynamic 
            :botList="botList" 
            :curtId="curtId" 
            :rentSaleType="rentSaleType"
            :query="query" 
            :recordList="recordList"
            :total="total"
            @handleGohouse="handleGohouse"
            @handledownload="handledownload"
            @pageChange="pageChange"
            @upStatus="upStatus"
             />
            
            <!-- 相关人员 -->
            <Person 
            :aboutPerson="aboutPerson" 
            :personList="personList" 
            :personTotal="personTotal" 
            :personTypeList="personTypeList" 
            :total="total"
            @personChange="personChange"
             />
            
          </div>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" tab="店铺推荐" force-render>
        <template v-if="type !== 'sale'">
          <demand-content :userInfo="userInfo"></demand-content>
        </template>
        <template v-else>
          <sell-demand-content :userInfo="userInfo"></sell-demand-content>
        </template>
        <a-divider />
        <div class="btn-box">
          <button class="btn" @click="onekeyPush">一键推铺</button>
        </div>
        <div class="shoplist-title" v-show="records.length">
          <div></div>
          <div></div>
          <div v-for="(v, i) in shopListTitle" :key="v">
            <div class="title-item" @click="handleSort(i)">
              <span :class="{ cur: curLook[i] }">{{ v }} </span>
              <div class="icon">
                <a-icon type="caret-up" :class="{ cur: curLook[i] && form.sortType == 'ASC' }" />
                <a-icon type="caret-down" :class="{ cur: curLook[i] && form.sortType == 'DESC' }" />
              </div>
            </div>
          </div>
        </div>
        <a-divider v-show="records.length" />
        <a-spin :spinning="loading">
          <houseList :records="records"></houseList>
        </a-spin>
        <div v-show="isShow">
          <a-pagination
            v-if="records.length"
            :current="form.pageNum"
            :page-size="form.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            :total="shopPagination.total"
            @change="onChange"
            class="dateli"
          />
          <div v-else>
            <no-data></no-data>
          </div>
        </div>
      </a-tab-pane>

      <a-tab-pane key="4" tab="自定义推铺" force-render>
        <searchForm pageName="rentDetail" :userInfo="userInfo"></searchForm>
      </a-tab-pane>

      <a-tab-pane key="3" tab="历史成交" v-if="isHistory">
        <HistoryTable 
        :columns="columns" 
        :tableLoading="tableLoading"
        :pagination="pagination"
        :customRow="getContractDetail"
        :tableData="transactionHistoryList"
        @handleChangeInTable="handleChangeInTable"
         >
            <!-- <a slot="name" slot-scope="text">{{ text }}</a>
          <template slot="contractCode" slot-scope="contractCode">
            <h1 style="color: var(--ThemeColor)">{{ contractCode }}</h1>
          </template> -->
         </HistoryTable>
        <!-- <a-table
          :rowKey="
            (record, index) => {
              return index
            }
          "
          :columns="columns"
          :loading="tableLoading"
          :pagination="pagination"
          @change="handleChangeInTable"
          :data-source="transactionHistoryList"
          :customRow="getContractDetail"
        >
          <a slot="name" slot-scope="text">{{ text }}</a>
          <template slot="contractCode" slot-scope="contractCode">
            <h1 style="color: var(--ThemeColor)">{{ contractCode }}</h1>
          </template>
        </a-table> -->
      </a-tab-pane>
    </a-tabs>
</template>

<script>
import DemandContent from '../../cards/demandContent.vue'
import sellDemandContent from '../../cards/sellDemandContent.vue'

import houseList from '@/components/houseList/houseList.vue'
import SearchForm from '../../cards/searchForm.vue'
import { contractsInfoList } from '@/api/system/contract'
import HistoryTable from './table.vue'
import Dynamic from '../modules/dynamic.vue'
import Person from '../modules/person.vue'
import Info from '../modules/info.vue'
// 表格数据
const columns = [
  {
    title: '合同',
    dataIndex: 'contractCode',
    key: '1',
    scopedSlots: {
      customRender: 'contractCode'
    }
  },
  {
    title: '品牌',
    dataIndex: 'lesseeBrandName',
    key: '2'
  },
  {
    title: '成交时间',
    dataIndex: 'signDate',
    key: '4',
    ellipsis: true
  },
  {
    title: '成交价格',
    dataIndex: 'rentExpense',
    key: '5',
    ellipsis: true
  },
  {
    title: '房佣',
    dataIndex: 'lessorComm',
    key: '6',
    ellipsis: true
  },
  {
    title: '客佣',
    dataIndex: 'lesseeComm',
    key: '7',
    ellipsis: true
  }
]
export default {
    components:{
        DemandContent, 
        sellDemandContent,
        houseList,
        SearchForm,
        HistoryTable,
        Dynamic,
        Person,
        Info
    },
    props: {
        rentSaleType:{
            type: [Number, String],
            default: 1
        },
        activeKey:{
          type:[Number,String],
          default:'1'
        },
        type:{
            type:String,
            default:''
        },
        userInfo: {
            type: Object,
            default:() => ({})
        },
        uidObj: {
            type: Object,
            default: () => ({})
        },
        botList: {
            type: Array,
            default: () => ({})
        },
        curtId: {
            type: [String, Number],
            default: ''
        },
        recordList: {
            type: Array,
            default: () => []
        },
        total:{
            type: [Number, String],
            default: 0
        },
        query: {
            type: Object,
            default: () => ({})
        },
        personList: {
            type:Array,
            default: () => []
        },
        personTotal: {
            type: [Number, String],
            default: 0
        },
        aboutPerson: {
            type: Object,
            default: () => ({})
        },
        records: {
            type:Array,
            default: () => []
        },
        shopListTitle: {
            type:Array,
            default: () => []
        },
        curLook: {
            type:Array,
            default: () => []
        },
        form: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default:false
        },
        isShow: {
            type: Boolean,
            default:false
        },
        shopPagination: {
            type: Object,
            default: () => ({})
        },
        personTypeList:{
            type: Array,
            default: () => []
        }
    },
    watch:{
        userInfo: {
            handler(){},
            deep: true,
            immediate: true
        },
        rentSaleType:{
           handler(){},
            deep: true,
            immediate: true
        },
        uidObj: {
            handler(){},
            deep: true,
            immediate: true
        },
        botList: {
            handler(){},
            deep: true,
            immediate: true
        },
        recordList: {
            handler(){},
            deep: true,
            immediate: true
        },
        query: {
            handler(){},
            deep: true,
            immediate: true
        },
        personList: {
            handler(){},
            deep: true,
            immediate: true
        },
        aboutPerson: {
            handler(){},
            deep: true,
            immediate: true
        },
        records: {
            handler(){},
            deep: true,
            immediate: true
        },
        curLook: {
            handler(){},
            deep: true,
            immediate: true
        },
        form: {
            handler(){},
            deep: true,
            immediate: true
        },
        shopPagination:{
            handler(){},
            deep:true,
            immediate:true
        },
        personTypeList:{
            handler(){},
            deep:true,
            immediate:true
        },
        activeKey:{
          handler(val){
            this.active = this.activeKey
            console.log(this.activeKey,'thi',this.active)
          },
          immediate:true
        }
    },
    data(){
    const userInfo = this.$getters.userInfo
    const isHistory = userInfo.data.permissions.includes('houses:houseInfo:makeHistory') || userInfo.data.permissions.includes('*:*:*')
   
        return {
          isHistory,
            columns,
            tableLoading: false,
            // 成交历史表格数据
            transactionHistoryList: [],
            // 分页参数
            pagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                // range[0] + '-' + range[1] +
                return ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            imgUrlpor: require('@/assets/home-imgs/头像.svg'),
            active:'1'
        }
    },
    methods:{
        // 切换tab选项
        changeTabs (tab) {
            if (tab == 2) {
                // this.getHouseList()
            } else if (tab == 3) {
                this.getTransactionHistoryList()
            }
            this.$emit('changeTabs',tab)
        },
        // 成交历史-----------------
        getTransactionHistoryList () {
            const params = {
                requirementId: this.$route.query.id,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
                contractType: '1'
            }
            this.tableLoading = true
            contractsInfoList(params).then(({ code, data }) => {
                this.tableLoading = false
                if (code === 200) {
                    this.transactionHistoryList = data.records
                    this.pagination.total = data.total
                }
            })
        },
        // 历史成交分页
        handleChangeInTable (pagination, filters, sorter) {
            // 分页、排序、筛选变化时触发
            this.pagination = pagination
            this.getTransactionHistoryList()
        },
        getContractDetail: function (record, index) {
            return {
                on: {
                click: () => {
                    this.$router.push({
                    path: '/contract/details',
                    query: { id: record.id }
                    })
                  }
                }
            }
        },
        // 获取相关人员类型
        personType (val, list) {
            if (!val) return
            for (const d of list) {
                if (d.dictValue == val) {
                return d.dictLabel
                }
            }
        },
        //点亮或者取消意向
        setIntentionFn(){
            this.$emit('setIntentionFn')
        },
        // 跟进
        toFollow(){
            this.$emit('toFollow')
        },
        // 带看
        openLookModal(){
            this.$emit('openLookModal')
        },
        // 面访
        openInterviewModal(){
            this.$emit('openInterviewModal')
        },
        // 更新状态
        upStatus(item){
            this.$emit('upStatus',item)
        },
        // 看房
        handleGohouse(item){
            this.$emit('handleGohouse', item)
        },
        // 下载
        handledownload(item){
            this.$emit('handledownload',item)
        },
        // 动态分页改变
        pageChange(page, pageSize){
            this.$emit('pageChange',page, pageSize)
        },
        // 人员分页改变
        personChange(page, pageSize){
            this.$emit('personChange',page, pageSize)
        },
        // 人员分页改变
        onChange(current, pageSize){
            this.$emit('onChange',current, pageSize)
        },
        // 一键推铺
        onekeyPush(){
            this.$emit('onekeyPush')
        },
        handleSort(item){
            this.$emit('handleSort',item)
        }
    }
}
</script>

<style lang="less" scoped>
//选项卡
  /deep/.ant-tabs-ink-bar {
    width: 0px !important;
  }
  /deep/.ant-tabs-tab-active {
    color: var(--ThemeColor);
    font-weight: 700;
  }
  /deep/.ant-tabs-tab {
    font-weight: 700;
  }
/deep/ .ant-tabs-nav-container{
  height: 50px;
}
  .demand {
    font-size: 20px;
    margin-top: 20px;
    font-weight: 700;
  }

  .bot-detail {
    margin: 40px 0 0 0px;
    width: 100%;
    border-top: 2px solid #f2f6fc;
    /deep/ .ant-col-12 {
      display: flex;
      padding-top: 20px;
      justify-content: space-between;
      & > p {
        font-size: 20px;
        font-weight: 700;
        color: black;
        margin-right: 20px;
        display: inline-block;
        margin-bottom: 0;
      }
      .child {
        margin-top: 20px;
        margin-right: 20px;
        & > span {
          font-size: 16px;
          color: var(--ThemeColor);
          font-weight: bold;
          margin-right: 10px;
        }
      }
    }
    .bot-detail-bot {
      width: 100%;
      height: 1100px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 40px;
      
    }
  }

  //店铺推荐
  .btn-box {
    width: 100%;
    height: 100px;
    position: relative;
    .btn {
      width: 260px;
      height: 50px;
      font-weight: 700;
      letter-spacing: 1px;
      color: white;
      border: none;
      cursor: pointer;
      border-radius: 26px;
      background-color: var(--ThemeColor);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .shoplist-title {
    display: flex;
    font-weight: 700;
    & > :nth-child(1) {
      height: 32px;
      width: 33.333%;
    }
    & > :nth-child(2) {
      width: 16.6%;
    }
    & > :nth-child(3) {
      width: 16.6%;
      position: relative;
      & > .title-item {
        width: 60px;
        position: absolute;
        left: -115%;
        top: 0;
      }
    }
    & > :nth-child(4) {
      width: 16.6%;
      position: relative;
      & > .title-item {
        width: 80px;
        position: absolute;
        left: -170%;
        top: 0;
      }
    }
    & > :nth-child(5) {
      width: 8%;
      position: relative;
      & > .title-item {
        width: 60px;
        position: absolute;
        left: -365%;
        top: 0;
      }
    }
    & > :nth-child(6) {
      width: 8%;
      position: relative;
      & > .title-item {
        width: 60px;
        position: absolute;
        left: 10%;
        top: 0;
      }
    }

    .title-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      .icon {
        display: flex;
        margin-left: 2px;
        flex-direction: column;
      }
      .cur {
        color: var(--ThemeColor);
      }
    }
  }
  
  .dateli {
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: right;
    margin-right: 30px;
  }
</style>